import { styled } from '@mui/material/styles';

export const WindowWrapper = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const MouseEventsContainer = styled('div')<{ padding: number }>`
  padding: ${({ padding }) => padding}px;
  position: fixed;
  pointer-events: all;
`;

export const Container = styled('div')`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  user-select: text;
  & > * {
    width: 100%;
    height: 100%;
  }
`;

export const Header = styled('div')`
  position: relative;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  user-select: none;
  padding: 12px 16px;
`;

export const HeaderLeft = styled('div')`
  height: 100%;
  flex: 1 1 auto;
`;

export const HeaderRight = styled('div')`
  flex: 0 0 auto;
  gap: 8px;
  display: flex;
`;

export const Body = styled('div')`
  flex: 1 1 auto;
  overflow: auto;
`;
